<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
  },
  beforeDestroy() {

  }
}

</script>

<style lang="scss">
@import "/assets/styles/variables";
@import "~bootstrap/scss/bootstrap";
@import "~bootstrap-vue/dist/bootstrap-vue";
@import "/assets/styles/bootswatch";
@import "bootstrap-icons/font/bootstrap-icons.css";
@import "/assets/styles/premium";

/* Ilumina el borde de los campos requeridos cuando están vacíos o inválidos */
/* Solo marca error si el usuario ya interactuó con el campo */
input:required:user-invalid,
select:required:user-invalid,
textarea:required:user-invalid {
  border: 2px solid #dc3545 !important;
  box-shadow: 0 0 5px rgba(220, 53, 69, 0.3);
}

/* Opcional: añade un check verde cuando sea válido */
input:required:valid,
select:required:valid {
  border: 1px solid #198754;
}

button {
  border-radius: 8px !important;
}

.sidebar {
  position: sticky;
  top: 0;
  z-index: 1030;
  /* mayor que el navbar, pero debajo de modales (1040/1050) */
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);
}

.navbar.sticky-top {
  z-index: 3;
  /* Navbar sigue encima */
}

footer.ew-footer {
  position: relative;
  z-index: 1;
  /* footer queda detrás del sidebar */
}

.card,
.v-card {
  border-radius: 0.75rem !important;
}

.ew-offline {
  width: 15rem;
}

nav.navbar {


  a {

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
}

.ew-budgeter-form {
  background: white;
  padding: 0.25rem;
}

.ew-budgeter-form .form-group {
  margin-bottom: 0;
  margin-right: 0.25rem;
}

.ew-budgeter-form .form-group:last-child {
  margin-right: 0;
}

.ew-clean-btn {
  border: 1px solid transparent;
  background: transparent;
  margin-bottom: 0.3rem;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }

  img {
    width: 2.5rem;
  }
}

.ew-features-section h3 {

  margin-bottom: 3rem;
  margin-top: 5rem;
  font-weight: 700;
}

.ew-feature-card {
  color: #fff;

  padding: 1rem;

  h4 {
    font-size: 1rem;
    font-weight: 600;
  }

  img {
    max-width: 7rem;
  }
}

.ew-footer {

  padding: 2rem;
  margin-top: 8rem;
  font-weight: 400;

  h4 {
    font-size: 17px;
    letter-spacing: 0px;
    line-height: 32px;
    margin-bottom: 0px;
    color: #073258;

    ;
    font-weight: 800;
  }
}

.ew-footer--primary {
  padding-top: 8%;
  color: #073258;
  background-image: url("./assets/images/footer-02.svg");
  background-size: 100% auto;
  background-position: center bottom;
  background-size: 100%;
  background-repeat: no-repeat;
}

.ew-footer a {
  color: #073258;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0px;
  line-height: 20px;
  color: #073258;

  ;
  font-weight: 500;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}

.ew-footer a:hover {
  color: #fff;
  text-decoration: underline;
}

.ew-footer ul {
  list-style: none;
}

.ew-border-left {
  position: relative;

  &::before {
    display: block;
    content: "";
    position: absolute;
    border-left: 3px solid #ffffff;
    height: 100%;
    left: 0;

  }
}

@media (max-width: 600px) {
  .ew-border-left {
    position: relative;

    &::before {
      display: none;
      content: "";
      position: absolute;
      border-left: 3px solid #ffffff;
      height: 100%;
      left: 0;

    }
  }
}

.ew-footer ul li:last-child {
  margin-bottom: 0;
}

.ew-form {
  max-width: 400px;
  margin: 0 auto;
}

.ew-home-jumbotron {
  position: relative;
  background-color: #d1d1d1;
  min-height: 40vmax;

  padding-bottom: 15rem;
  background-repeat: no-repeat;
}

.ew-home-jumbotron h2 {
  font-size: 2.25rem;

  font-weight: 700;
  margin: 1em;
}

.ew-home-jumbotron label {

  color: $primary;
}

.ew-icon:hover {
  display: inline-block;
  text-decoration: none;
  transform: scale(1.1);
}

.ew-icon img {
  height: 2rem;
}

.ew-navbar-icon {
  display: inline-block;
  height: 1.5rem;
  width: 1.5rem;

  &-sm {
    height: 1rem;
    width: 1rem;
  }
}

.ew-login-form {
  background-color: $white;
  padding: 2rem 8rem 2rem 3rem;

  min-height: 100vh;

  a {
    color: $primary;

    &:hover {
      color: darken($primary, 10%);
    }
  }
}

.ew-login-form form {}

.ew-login-layout {
  min-height: 100vh;
  background-color: #ededed;
}

.ew-login-layout .form-group {
  margin-bottom: 2rem;
}

.ew-login-layout>.container {
  background-color: $primary;
  //background-image: url("./assets/images/ew-pattern.jpg");
}

.ew-login-layout>.container>.row {
  min-height: 100vh;
}

.ew-login-logo {
  height: 4.7rem;
  margin-bottom: 2rem;
}

.ew-login-pattern {
  min-height: 100vh;
}

.ew-login-signup-hint {
  margin-bottom: 2rem;
  color: #9e9e9e;
}

.ew-login-signup-hint a {

  color: $primary;
}

.ew-navbar {
  border-bottom: 2px solid $primary;
}

.ew-navbar-dropdown {

  .dropdown-toggle,
  .btn {
    padding: 0;

    img {
      max-height: 2rem;
    }
  }
}

.ew-navbar-logo {
  height: 2.8rem;
}

.ew-service-provider-filter {
  margin-bottom: 1.25rem;
}

.ew-service-provider-filter:last-child {
  margin-bottom: 0;
}

.ew-service-provider-filter .ew-filter-heading {
  color: $primary;
  line-height: 100%;
  font-weight: 700;

  font-size: 1rem;
  margin-bottom: 1rem;
}

.ew-service-provider-filter .ew-filter-body {
  margin-left: 1rem;
}

.ew-shipment-option-card {
  background-color: #fff;
  border: 1px solid #bababa;
  padding: 1rem;

  &:hover {
    background-color: transparentize($primary, 0.95);
  }

  .small-text {
    font-size: 0.8em;
  }
}

.ew-datails-option-shipment {
  cursor: pointer;
  font-size: 0.6
}

.ew-shipment-option-card--price {
  color: $primary;
  font-size: 1.2rem;
  text-align: right;

  p {
    text-align: right;
  }
}

.ew-checkbox {
  position: relative;
}

.ew-checkbox:after {
  content: "x";
  position: absolute;
  left: -16px;
}

.ew-smaller-container {
  max-width: 1000px;
  margin: 0 auto;
}

.ew-section-header {

  font-weight: 700;
  border-bottom: 1px solid #bababa;
  margin-bottom: 1.75rem;
  margin-top: 4rem;
  padding-bottom: 1rem;

  &--no-margin {
    margin-top: 0;
  }
}

.ew-tabs {
  border-bottom: 1px solid $gray-500;
  // margin-bottom: 3rem;
}

.ew-bg-gray {
  background-color: #f3f3f3;
  //background-color: red;
}

.no-radius-left {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.no-radius-right {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.no-padding {
  padding: 0;
}

.no-grow {
  flex-grow: 0;
}

.alt-font {
  font-family: $font-family-sans-serif-heading;
}

.ew-bigger-line-height {
  line-height: 2;
}

// List Utilities
.ew-list-roman-styles {
  counter-reset: list;

  &>li {
    list-style: none;
    position: relative;
  }

  &>li:before {
    counter-increment: list;
    content: counter(list, upper-roman) ". ";
    font-weight: bold;
    position: absolute;
    left: -1.4em;
  }
}

.ew-list-latin-styles {
  counter-reset: list;

  &>li {
    list-style: none;
    position: relative;
  }

  &>li:before {
    counter-increment: list;
    content: counter(list, lower-alpha) ") ";
    position: absolute;
    left: -1.4em;
  }
}

#app {
  overflow-x: hidden;
  /* clip recorta igual que hidden pero no crea un contenedor de scroll,
     así el menú lateral (position: sticky) se mantiene fijo al bajar */
  overflow-x: clip;
}

/* La columna de contenido junto al menú debe encogerse al espacio libre;
   sin min-width: 0 se estira al ancho de las tablas y se corta a la derecha */
.sw-wrapper > .w-100 {
  flex: 1 1 0;
  min-width: 0;
}

.ew-text-warranty {
  font-size: 14px
}

.txt-f1 {
  margin-top: 10px;
}

.pdn-l1 {
  text-align: left;
  font-weight: bold;
}

@media (max-width: 852px) {
  .ew-smaller-container {
    max-width: 100%;
    padding: 0px 15px;
  }
}

@media (max-width: 991px) {
  .ew-navbar-icon {
    height: 1.2rem;
    width: 1.2rem;
  }
}

@media (max-width: 768px) {
  .title-2 {
    font-size: 1.1rem;
    margin-bottom: 30px;
    margin-top: 0 !important;
  }
}

@media (max-width: 767px) {

  .navbar-nav {
    margin-top: 20px;
  }

  .ew-navbar-icon {
    display: none;
  }

  .pl1 {
    padding-left: 40px;
  }

  select[data-v-2dcb1cf7] {
    font-size: 0.7rem;
  }

  footer .ew-icon img {
    height: 3rem;
  }

  .input-group[data-v-9ddb17c0] {
    margin-bottom: 15px;
  }

  .pdn-l1 {
    padding-left: 46px;
  }
}

@media (max-width: 575px) {

  footer ul,
  .pl1 {
    padding: 0px;
  }

  .pdn-l1 {
    padding-left: 6px;
  }
}

@media (max-width: 425px) {
  select[data-v-2dcb1cf7] {
    font-size: 0.9375rem;
  }

  .ew-loading-indicator .inner-container {
    overflow-x: hidden;
    width: 100%;
  }

  .align-self-center.inner-container img {
    width: 300px;
    height: 300px;
  }

  .title-2,
  .ew-loading-indicator .font-weight-bold {
    font-size: 1rem;
    padding: 0px 15px;
  }
}

.ew-smaller-container-quoting {
  max-width: 1000px;
  margin: 0 auto;
}

@media (max-width: 852px) {
  .ew-smaller-container-quoting {
    max-width: 100%;
    padding: 0px 15px;
  }
}

.ew-area-remote {
  color: $primary;
}

.ew-table-datails {

  .table th,
  .table td {
    padding: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem
  }
}

.ew-white {
  background-color: #ffffff;
}

.ew-height {
  height: 100%;
}

.ew-box-shadow {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
}

#app {
  height: 100%;
}

.ew-section-header-edit {

  font-weight: 700;

  padding-bottom: 1rem;

  &--no-margin {
    margin-top: 0;
  }
}

.ew-border-radius {
  border-radius: 2px
}

.ew-font-size--popovers {
  font-size: 0.72rem
}


.ew-cursor {
  cursor: pointer;
}

.ew-conten-payment {
  padding: 1.8rem;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);

}

.ew-imag-payment {
  max-width: 94px;
  margin-top: -79px;
}

.ew-mar-none {
  margin-top: 0
}

.ew-custom-dropdown-navbar {
  .dropdown-menu {
    background-color: #f6f7f7;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
    border-radius: 0px;
    border: none;

  }

  .dropdown-menu::after {
    content: '';
    display: inline-block;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #f6f7f7;
    /* change color here, modified for a black arrow */
    position: absolute;
    top: -10px;
    left: 90%;
  }
}

.ew-custom-dropdown-navbar {
  .ew-help-dropdown {
    .dropdown-menu {
      background-color: #f6f7f7;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
      border-radius: 0px;
      border: none;

    }

    .dropdown-menu::after {
      content: '';
      display: inline-block;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #f6f7f7;
      /* change color here, modified for a black arrow */
      position: absolute;
      top: -10px;
      left: 5%;
    }
  }
}

.ew-radio-image {
  width: 75px;
}

.ew-custom-control-label {
  margin-left: 0.5rem
}

.ew-from-control--input {
  border: 1px solid #ced4da;
}

.ew-from-control--input-primary {
  border: 1px solid $primary;
}

/*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
@font-face {
  font-family: "Gotham Black";
  src: url("./assets/fonts/gotham/Gotham-Black/Gotham-Black.otf") format("opentype");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Black";
  src: url("./assets/fonts/gotham/Gotham-Black/Gotham-Black.otf") format("opentype");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Bold";
  src: url("./assets/fonts/gotham/Gotham-Bold/Gotham-Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Bold Italic";
  src: url("./assets/fonts/gotham/Gotham-Bold-Italic/Gotham-Bold-Italic.ttf") format("opentype");
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: "Gotham Book";
  src: url("./assets/fonts/gotham/Gotham-Book/Gotham-Book.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Extra Light";
  src: url("./assets/fonts/gotham/Gotham-Extra-Light/Gotham-Extra-Light.otf") format("opentype");
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Extra Light Italic";
  src: url("./assets/fonts/gotham/Gotham-Extra-Light-Italic/Gotham-Extra-Light-Italic.otf") format("opentype");
  font-weight: 200;
  font-style: italic;
}

@font-face {
  font-family: "Gotham Italic";
  src: url("./assets/fonts/gotham/Gotham-Italic/Gotham-Italic.otf") format("opentype");
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Gotham ItalicBold";
  src: url("./assets/fonts/gotham/Gotham-Italic-Bold/Gotham-Italic-Bold.otf") format("opentype");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "Gotham Light";
  src: url("./assets/fonts/gotham/Gotham-Light/Gotham-Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Medium";
  src: url("./assets/fonts/gotham/Gotham-Medium/Gotham-Medium.otf") format("opentype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Regular";
  src: url("./assets/fonts/gotham/Gotham-Regular/Gotham-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Thin";
  src: url("./assets/fonts/gotham/Gotham-Thin/Gotham-Thin.otf") format("opentype");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Thin Italic";
  src: url("./assets/fonts/gotham/Gotham-Thin-Italic/Gotham-Thin-Italic.otf") format("opentype");
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: "Gotham Ultra";
  src: url("./assets/fonts/gotham/Gotham-Ultra/Gotham-Ultra.otf") format("opentype");
  font-weight: 950;
  font-style: normal;
}


.ew-profile-header {
  margin-top: 0.5rem;
  margin-bottom: 2rem;
}

.ew-cursor-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue